import { getDefaultOptions as getInternalDefaultOptions } from "../_lib/defaultOptions/index.js";
import assign from "../_lib/assign/index.js";
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions]{@link https://date-fns.org/docs/setDefaultOptions}.
 *
 * @returns {Object} default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */
export default function getDefaultOptions() {
  return assign({}, getInternalDefaultOptions());
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/getDefaultOptions/index.js
// module id = ./node_modules/date-fns/esm/getDefaultOptions/index.js
// module chunks = 1